import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const procurementPendingReceiptsWidget: DashboardWidgetConfiguration = {
  widgetId: "procurement.pending-receipts",
  name: "Pending receipts",
  description: "Pending receipts for the selected dashboard period.",
  apps: [
    "home",
    "procurement",
  ],
  template: "number",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "procurement.purchases",
      ...period(30),
      select: [
        {
          type: "aggregate",
          function: "count_distinct",
          field: "purchase_id",
          as: "value",
        },
      ],
      where: {
        type: "condition",
        field: "receipt_status",
        operator: "ne",
        value: "received",
      },
    },
  },
  inputs: {
    label: "Pending receipts",
    subtext: "in the last 30 days",
    icon: "orders",
    color: "warning",
    valueFormat: "number",
    valueMultiplier: 1,
  },
  dummyData: {
    value: 13,
    subtext: "Last 30 days",
  },
  limits: {
    minWidth: 2,
    maxWidth: 6,
    minHeight: 1,
    maxHeight: 2,
    defaultWidth: 4,
    defaultHeight: 1,
  },
};
